
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-defi-framework/api/legacy/convert_utxo_address",
      function () {
        return require("private-next-pages/en/docs/komodo-defi-framework/api/legacy/convert_utxo_address/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-defi-framework/api/legacy/convert_utxo_address"])
      });
    }
  